import { Notify, Toast } from 'vant';
//全局js文件
//session 存值
export function s_set(name,val){
    sessionStorage.setItem(name,JSON.stringify(val))
}
// session 取值
export function s_get(name){
    return JSON.parse(sessionStorage.getItem(name))
}
//手机号检验
export function phone(num){
    
    if(!(/^\d{11}$/.test(num))){ 
        // alert('请您输入11位手机号');  
        Toast('请您输入11位手机号');
        return false; 
    }else if( !(/^1[3456789]\d{9}$/.test(num)) ){
        // alert('请您输入的手机号不正确');  
        Toast('请您输入的手机号不正确');
        return false; 
    }else{
        return true
    }
}
//身份证检验
export function identity(num){
    var idcardReg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if(num.length != 18){
        alert('请您输入的身份证号不正确');  
        return false;
    }else if(!idcardReg.test(num)){ 
        alert('请您输入的身份证号不正确');  
        return false; 
    }
}
// 邮箱验证
export function Email(num){
    var Email = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
    if(!Email.test(num)){ 
        Toast('请您输入正确的邮箱');  
        return false; 
    }
    else {
        return true
    }
}
//验证码检验
export function Verification(num){
    if(num == "" || num == undefined){
        Notify('验证码不能为空');
        return false;
    }else if(num.length < 4){
        Notify('验证码必须是4位');
        return false
    }else if(num.length == 4){
        return true;
    }
}
//验证密码

export function CheckPassWord1(password) {//必须为字母加数字且长度不小于8位
    var str = password;
     var reg1 = new RegExp(/^[0-9A-Za-z]+$/);
     if (!reg1.test(str)) {
        Notify('不能输入特殊字符');
         return false;
     }
     var reg = new RegExp(/[A-Za-z].*[0-9]|[0-9].*[A-Za-z]/);
     if (reg.test(str)) {
         return true;
     } else {
        Notify('密码必须有两种字符');
         return false;
     }
 }
 // 联系人验证
export function contacts(num){
    var contacts = /^[A-Za-z\u4e00-\u9fa5]+$/;
    if(!contacts.test(num)){
        Toast('请您输入正确姓名');
        return false;
    }else{
        return true
    }
}

 //首页轮播图拼接地址
 export let cdn_tu = "https://static.horizou.cn/"

 //微信appid
 export let appid = "wxa1fb530295fba5d7"

 export function getQueryVariable(variable){
     var query = window.location.search.substring(1);
     var vars = query.split("&");
     for (var i=0;i<vars.length;i++) {
             var pair = vars[i].split("=");
             if(pair[0] == variable){
                 return pair[1];
            }
     }
     return(false);
 }


// WEBPACK FOOTER //
// ./src/public/index.js